module.exports = __webpack_public_path__ + "static/img/ZJKG.9a9355a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/ZJKG.png
// module id = pWSS
// module chunks = 34